import React, { forwardRef } from 'react'
import { useTranslation } from 'react-i18next';
import { editPhoneNumberDetails } from '../../../apiclients/streamsapi_bridge';

const PHChangeCallRoutingWarn = forwardRef((props, ref) => {
    const { t, i18n } = useTranslation();
    
    async function allowToChange(e) {
        console.log(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
        let update = { ...props.finalData, save_flag: true }
        console.log(update);
        props.setIsloading(true);
        let saverep = await editPhoneNumberDetails(update, "");
        console.log(`reponse of phone edit :::: ${JSON.stringify(saverep)}`);
        let saverepeMsg = await saverep.json();
        console.log(
            "response of modified data :::" + JSON.stringify(saverepeMsg)
        );
        setTimeout(() => {
            props.setIsloading(false);
        }, 1000);
        if (saverepeMsg.status && saverepeMsg.status == "success") {
            props.setRerender(true);
            props.setSuccessMessage(saverepeMsg.message);
        } else {
            props.setRerender(true);
            props.onClose();
        }

    }
    return (
        <>
            <div>
                <span className="phrecording">{props.warningMessage}</span>
            </div>

            <div style={{ display: "none" }}>
                <button ref={ref} onClick={(e) => allowToChange(e)}>
                    {t("ok")}</button>
            </div>

            {/* <MDBModalFooter>
                <MDBBtn color="secondary" onClick={props.onClose}>
                    {t("cancel")}
                </MDBBtn>
                <MDBBtn onClick={(e) => removeThisNumber(e)}>{t("remove")}</MDBBtn>
            </MDBModalFooter> */}
        </>
    );
});

export default PHChangeCallRoutingWarn
